import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class EditorBrokerService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getInstitutos() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
  }

  getJsons(broker: number) {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.editorBroker.getJson + broker.toString());
  }

  update(idJson: any, datos: any) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.editorBroker.update + idJson, datos);
  }

  getFlag(broker: number){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.editorBroker.getFlag + broker.toString());
  }

  updateFlag(idFlag: any, datos: any) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.editorBroker.updateFlag + idFlag, datos);
  }

  getCorreos(broker: number){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.editorBroker.correos.get + broker.toString());
  }

  updateCorreos(idTemplate: any, datos: any) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.editorBroker.correos.update + idTemplate, datos);
  }
}
